import React from 'react';
// eslint-disable-next-line
import { useDragLayer } from 'react-dnd';
import styles from '../index.module.css';

const DragLayer = () => {
  const {
    item,
    itemType,
    currentOffset,
    isDragging,
  } = useDragLayer((monitor) => ({
    item: monitor.getItem(),
    itemType: monitor.getItemType(),
    currentOffset: monitor.getSourceClientOffset(),
    isDragging: monitor.isDragging(),
  }));

  if (!isDragging || itemType !== 'VIDEO_CARD') {
    return null;
  }

  const layerStyles = {
    position: 'fixed',
    pointerEvents: 'none',
    zIndex: 1000,
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
  };

  const itemStyles = currentOffset ? {
    transform: `translate(${currentOffset.x}px, ${currentOffset.y}px)`,
  } : {
    display: 'none',
  };

  return (
    <div style={layerStyles}>
      <div style={itemStyles}>
        <div
className={`${styles.videoCard} ${styles.dragPreview}`}
style={{
          width: '200px',
          height: '120px',
          backgroundColor: '#f8f9fa',
          border: '2px dashed #007bff',
          borderRadius: '8px',
          padding: '10px',
          boxShadow: '0 4px 8px rgba(0,0,0,0.2)',
          transform: 'rotate(5deg)',
        }}
        >
          <div style={{
            fontSize: '14px',
            fontWeight: 'bold',
            color: '#007bff',
            textAlign: 'center',
            padding: '20px 0',
          }}
          >
            📹
{' '}
{item?.title || 'Video'}
          </div>
          <div style={{
            fontSize: '12px',
            color: '#6c757d',
            textAlign: 'center',
          }}
          >
            Drop in category
          </div>
        </div>
      </div>
    </div>
  );
};

export default DragLayer;
